// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"53749325","952":"99e81b78"}[chunkId] + ".chunk.js";
};